import React, { memo } from "react";
import ViewTypeToggle from "./ViewTypeToggle";
import ViewControls from "./ViewControls";
import PersonFilter from "./PersonFilter";
import ActionButtons from "./ActionButtons";

const Header = memo(function Header({
  viewType,
  setViewType,
  handleRefresh,
  handlePrevious,
  handleNext,
  handleToday,
  currentDate,
  currentWeekStart,
  personColumnId,
  personColumnIdMap,
  selectedPerson,
  setSelectedPerson,
  availablePeople,
  setShowNewTaskPopup,
  handleExportPDF,
  onBoardChange,
  onPropertyPanelToggle,
}) {
  return (
    <div
      style={{
        padding: "16px 16px",
        flexShrink: 0,
        borderBottom: "1px solid #e6e9ef",
        background: "#ffffff",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, position: "relative" }}>
        {viewType === "weekly" ? (
          <>
            <div style={{ flex: 1, display: "flex", alignItems: "center", gap: "8px" }}>
              {onPropertyPanelToggle && (
                <button
                  onClick={onPropertyPanelToggle}
                  style={{
                    padding: "8px",
                    backgroundColor: "transparent",
                    color: "#323338",
                    border: "1px solid #e6e9ef",
                    borderRadius: "4px",
                    fontSize: "16px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "32px",
                    height: "32px",
                  }}
                  title="Property Profile"
                >
                  🏠
                </button>
              )}
            </div>
            <h1 style={{ margin: 0, fontSize: 18, textAlign: "center", flex: 1 }}>Tasks by property</h1>
            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px" }}>
              <ViewTypeToggle
                viewType={viewType}
                setViewType={setViewType}
                handleRefresh={handleRefresh}
              />
              {onBoardChange && (
                <button
                  onClick={onBoardChange}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: "#0073ea",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    fontSize: "12px",
                    cursor: "pointer"
                  }}
                >
                  Change Board
                </button>
              )}
            </div>
          </>
        ) : (
          <>
            <h1 style={{ margin: 0, fontSize: 18 }}>Tasks by property</h1>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <ViewTypeToggle
                viewType={viewType}
                setViewType={setViewType}
                handleRefresh={handleRefresh}
              />
              {onBoardChange && (
                <button
                  onClick={onBoardChange}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: "#0073ea",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    fontSize: "12px",
                    cursor: "pointer"
                  }}
                >
                  Change Board
                </button>
              )}
            </div>
          </>
        )}
      </div>

      <ViewControls
        viewType={viewType}
        currentDate={currentDate}
        currentWeekStart={currentWeekStart}
        handlePrevious={handlePrevious}
        handleNext={handleNext}
        handleToday={handleToday}
      />

      {(personColumnId || (personColumnIdMap && Object.keys(personColumnIdMap).length > 0) || (availablePeople && availablePeople.length > 0)) && (
        <div style={{ marginTop: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <PersonFilter
            selectedPerson={selectedPerson}
            setSelectedPerson={setSelectedPerson}
            availablePeople={availablePeople}
          />
          <ActionButtons
            setShowNewTaskPopup={setShowNewTaskPopup}
            handleExportPDF={handleExportPDF}
          />
        </div>
      )}
      {!(personColumnId || (personColumnIdMap && Object.keys(personColumnIdMap).length > 0) || (availablePeople && availablePeople.length > 0)) && (
        <div style={{ marginTop: 12, display: "flex", justifyContent: "center", alignItems: "center", gap: 8 }}>
          <ActionButtons
            setShowNewTaskPopup={setShowNewTaskPopup}
            handleExportPDF={handleExportPDF}
          />
        </div>
      )}
    </div>
  );
});

export default Header;

